import { Document, EntityType } from '@/types'
import { Box, CircularProgress } from '@mui/material'
import { Stack } from '@mui/material'
import { Typography } from '@mui/material'
import { DocumentPreview } from './preview'

type DocumentInputContentProps = {
  maxFiles: number
  isDragActive: boolean
  isUploading: boolean
  files: Document[]
  entity: { key: string; type: EntityType }
  acceptTypes: string[]
}

export const DocumentInputContent = ({
  maxFiles,
  isDragActive,
  isUploading,
  files,
  entity,
  acceptTypes,
}: DocumentInputContentProps) => {
  const AcceptedFilesFormat = () => {
    return (
      <Typography variant="body2" color="textDisabled">
        {acceptTypes
          ? `(${acceptTypes.join(', ')})`
          : '(.pdf, .jpg, .jpeg, .png)'}
      </Typography>
    )
  }

  return (
    <Stack spacing={2}>
      <Box>
        <Typography variant="body2">
          {files.length === maxFiles
            ? `Máximo de ${maxFiles} arquivos atingido`
            : `${files.length} de ${maxFiles} arquivos.`}
        </Typography>
        <AcceptedFilesFormat />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 2,
        }}
      >
        {files.map((file, index) => (
          <DocumentPreview
            key={index}
            file={file}
            previewUrl={file.url || ''}
            entity={entity}
          />
        ))}

        {isUploading && (
          <Box>
            <CircularProgress sx={{ marginLeft: 2 }} />
          </Box>
        )}
      </Box>

      {files.length < maxFiles && (
        <Typography variant="h6" color="text.secondary" mt={2}>
          {isDragActive
            ? 'Solte para adicionar arquivo...'
            : 'Arraste e solte arquivos aqui, ou clique para selecionar'}
        </Typography>
      )}
    </Stack>
  )
}
